// start 1211511238800337
document.querySelectorAll('button[data-option-value]').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
    })
});
document.querySelectorAll('.cb-thumbnail')?.forEach((el) => {
    const galleryContainer = document.querySelector('.product__media-container.above-mobile .product__media');
    el.addEventListener('click', e => {
        const mediaId = el.dataset.thumbnailMediaId;
        if (!mediaId) return;
        el.querySelector('.cb-thumbnail .product-thumbnails__item-link.active')?.classList.remove('active');
        el.querySelector('.product-thumbnails__item-link').classList.add('active');
        galleryContainer.querySelectorAll('.cb-product-media-item').forEach((mediaItem) => {
            mediaItem.classList.add('cb-hidden');
        });
        galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('cb-hidden');
        galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('hidden');
    });
});
document.addEventListener('product:variant-change', (e) => {
    document.querySelector('[data-current-selected-variant-id]')?.setAttribute('data-current-selected-variant-id', e.detail.variant.id);
    const thumbnailsContainer = document.querySelector('.product-thumbnails__items');
    const thumbnailsHiddenContaner = document.querySelector('.cb-variants-thumbnails-container');
    const galleryContainer = document.querySelector('.product__media-container.above-mobile .product__media');
    const galleryHiddenContainer = document.querySelector('.cb-variants-images-container');
    const swiperWrapper = document.querySelector('.product__media-container .swiper-wrapper');
    const slidesHiddenContainer = document.querySelector('.cb-variants-slides-container');
    if (!thumbnailsHiddenContaner && !galleryHiddenContainer && !slidesHiddenContainer) return;
    
    if(screen.width >= 768) {
    // update thumbnails
    
        let thumbnails = thumbnailsHiddenContaner?.querySelectorAll(`[data-thumbnail-for-variant="${e.detail.variant.id}"]`);
        if (thumbnails && thumbnails.length === 0) thumbnails = thumbnailsHiddenContaner?.querySelectorAll('.cb-product-default-thumbnail');
        if (thumbnails && thumbnails.length > 0){
            const thumbnailsHtml = Array.from(thumbnails).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                if (index === 0) cloneEl.querySelector('.product-thumbnails__item-link').classList.add('active');
                return acc+= cloneEl.outerHTML;
            }, '');
            thumbnailsContainer.innerHTML = thumbnailsHtml;
            thumbnailsContainer.querySelectorAll('.cb-thumbnail').forEach((el) => {
                el.addEventListener('click', e => {
                    const mediaId = el.dataset.thumbnailMediaId;
                    if (!mediaId) return;
                    galleryContainer.querySelectorAll('.cb-product-media-item').forEach((mediaItem) => {
                        mediaItem.classList.add('cb-hidden');
                    });
                    galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('cb-hidden');
                    galleryContainer.querySelector(`[data-media-item-id="${mediaId}"]`).classList.remove('hidden');
                    thumbnailsContainer.querySelector('.product-thumbnails__item-link.active')?.classList.remove('active');
                    el.querySelector('.product-thumbnails__item-link').classList.add('active');
                });
            });
        } 

    // update gallery on desktop
        let galleryImages = galleryHiddenContainer.querySelectorAll(`[data-media-for-variant="${e.detail.variant.id}"]`);
        if (galleryImages && galleryImages.length === 0) galleryImages = galleryHiddenContainer.querySelectorAll('.cb-default-product-media-item');
        if (galleryImages && galleryImages.length > 0) {
            const galleryImagesHtml = Array.from(galleryImages).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                if (index > 0) cloneEl.classList.add('cb-hidden');
                return acc += cloneEl.outerHTML;
            }, '');
            galleryContainer.innerHTML = galleryImagesHtml;
        }
    }

    // update gallery on mobile
    if(screen.width < 767) {
        if (!swiperWrapper) return;
        swiperWrapper.querySelectorAll('.swiper-slide').forEach(el => el.remove());
        let gallerySlides = slidesHiddenContainer.querySelectorAll(`[data-media-for-variant="${e.detail.variant.id}"]`);
        if (gallerySlides.length === 0) gallerySlides = slidesHiddenContainer.querySelectorAll('.cb-default-product-swiper-slide');
        if (gallerySlides.length > 0) {
            const gallerySlidesHtml = Array.from(gallerySlides).reduce((acc, el, index) => {
                const cloneEl = el.cloneNode(true);
                cloneEl.setAttribute('data-slide-index', index);
                return acc += cloneEl.outerHTML;
            }, '');
            swiperWrapper.innerHTML = gallerySlidesHtml;
        }
        swiperWrapper.closest('.swiper').querySelector('.swiper-pagination-bullet')?.click();
    }
});
// end 1211511238800337